import { widgetApi } from "../services/api";

/** Mints a payout-claim link — POST /widget/links/:linkId/deferred-payout */
export interface GenerateDeferredPayoutLinkInput {
  sourceCountry: string;
  destinationCountry: string;
  sourceCurrency: string;
  destinationCurrency: string;
  sendAmount: number;
  totalDebit: number;
  fundingMethod: string;
  fundingPaymentMethodId?: string;
  recipientName: string;
  expiresInMinutes?: number;
}

export interface GenerateDeferredPayoutLinkResult {
  url: string;
  linkId: string;
  expiresAt: string;
  originationId: string;
  /** Sender first name read fresh at mint time; absent while CIP is pending. */
  senderFirstName?: string;
}

interface GenerateDeferredPayoutLinkApiResponse {
  success: boolean;
  data: GenerateDeferredPayoutLinkResult;
}

export const generateDeferredPayoutLink = async (
  linkId: string,
  input: GenerateDeferredPayoutLinkInput,
): Promise<GenerateDeferredPayoutLinkResult> => {
  const { data } = await widgetApi.post<GenerateDeferredPayoutLinkApiResponse>(
    `/widget/links/${linkId}/deferred-payout`,
    input,
  );
  return data.data;
};
